
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
  CONTRACT_PENDING_ACTION,
  GET_PENDING_CONTRACT,
  GET_ENDING_CONTRACT,
  GET_CANCEL_CONTRACT,
  GET_ACCEPT_CONTRACT,
  GET_STUDENT_PROGRAM_INCLUSION,
  GET_STUDENT_PROGRAM,
  GET_NEW_CONTRACT,
  GET_MONTH_CONTRACT,
  GET_CONTRACT_INSTALLMENT,
  UPDATE_INSTALLMENT_STATUS,
  SEND_EMAIL_CONTRACT_NOTIFICATION,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';

export const getPendingContract = () => {

  return (dispatch) => {
    dispatch({ type: CONTRACT_PENDING_ACTION });
    return axios.get(AppConfig.apiurl + '/api/getpendingcontract', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: GET_PENDING_CONTRACT, payload: alldata });
      });
  }

}

export const getEndingContract = () => {

  return (dispatch) => {
    dispatch({ type: CONTRACT_PENDING_ACTION });
    return axios.get(AppConfig.apiurl + '/api/getendingcontract', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: GET_ENDING_CONTRACT, payload: alldata });
      });
  }

}
 
export const getCancelContract = () => {

  return (dispatch) => {
    dispatch({ type: CONTRACT_PENDING_ACTION });
    return axios.get(AppConfig.apiurl + '/api/getcancelcontract', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: GET_CANCEL_CONTRACT, payload: alldata });
      });
  }

}

export const getAcceptContract = () => {

  return (dispatch) => {
    dispatch({ type: CONTRACT_PENDING_ACTION });
    return axios.get(AppConfig.apiurl + '/api/getacceptcontract', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: GET_ACCEPT_CONTRACT, payload: alldata });
      });
  }

}

export const getNewContract = () => {

  return (dispatch) => {
    dispatch({ type: CONTRACT_PENDING_ACTION });
    return axios.get(AppConfig.apiurl + '/api/getnewcontract', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: GET_NEW_CONTRACT, payload: alldata });
      });
  }

}

export const studentProgramInclusion = (id) => async (dispatch) => {
  var payload = {
    "id": id,
  }
  dispatch({ type: CONTRACT_PENDING_ACTION });
  axios.post(AppConfig.apiurl + '/api/getstudentprograminclusion', payload, { headers: AuthHeader.header })
  .then(response => {
    const alldata = response.data.data;
    dispatch({ type: GET_STUDENT_PROGRAM_INCLUSION, payload: alldata });
  });
}

export const getStudentPrograms = (id) => async (dispatch) => {
  var payload = {
    "id": id,
  }
  dispatch({ type: CONTRACT_PENDING_ACTION });
  axios.post(AppConfig.apiurl + '/api/getstudentprogram', payload, { headers: AuthHeader.header })
  .then(response => {
    const alldata = response.data.data;
    dispatch({ type: GET_STUDENT_PROGRAM, payload: alldata });
  });
}

export const getMonthEndContract = (seldate) => async (dispatch) => {
  var payload = {
    "date": seldate,
  }
  dispatch({ type: CONTRACT_PENDING_ACTION });
  axios.post(AppConfig.apiurl + '/api/getmonthpendingcontract', payload, { headers: AuthHeader.header })
  .then(response => {
    const alldata = response.data.data;
    dispatch({ type: GET_MONTH_CONTRACT, payload: alldata });
  });
}


export const getMonthContractInstallment = (seldate,status) => async (dispatch) => {
  var payload = {
    "date": seldate,
    "status":status
  }
  dispatch({ type: CONTRACT_PENDING_ACTION });
  axios.post(AppConfig.apiurl + '/api/getmonthcontractinstallment', payload, { headers: AuthHeader.header })
  .then(response => {
    const alldata = response.data.data;
    dispatch({ type: GET_CONTRACT_INSTALLMENT, payload: alldata });
  });
}

export const updateInstallmentStatus = (feeid,paymentstatus,paymentnote) => async (dispatch) => {
    var payload = {
      "id": feeid,
      "status": paymentstatus,
      "notes": paymentnote
    }
    dispatch({ type: CONTRACT_PENDING_ACTION });
    axios.post(AppConfig.apiurl + '/api/updatecontractinstallment', payload, { headers: AuthHeader.header })
    .then(response => {
      var resdata = response.data;
      NotificationManager.success(resdata.message);
      dispatch({ type: UPDATE_INSTALLMENT_STATUS });
    });
}

export const emailContractPending = (ctid) => async (dispatch) => {
  var payload = {
    "id": ctid
  }
  dispatch({ type: CONTRACT_PENDING_ACTION });
  axios.post(AppConfig.apiurl + '/api/emailcontractpending', payload, { headers: AuthHeader.header })
  .then(response => {
    var resdata = response.data;
    if(resdata.status==1){
      NotificationManager.success(resdata.message);
    }else{
      NotificationManager.error(resdata.message);
    }
    dispatch({ type: SEND_EMAIL_CONTRACT_NOTIFICATION });
  });
}


export const emailContractEnding = (ctid) => async (dispatch) => {
  var payload = {
    "id": ctid
  }
  dispatch({ type: CONTRACT_PENDING_ACTION });
  axios.post(AppConfig.apiurl + '/api/emailcontractending', payload, { headers: AuthHeader.header })
  .then(response => {
    var resdata = response.data;
    if(resdata.status==1){
      NotificationManager.success(resdata.message);
    }else{
      NotificationManager.error(resdata.message);
    }
    dispatch({ type: SEND_EMAIL_CONTRACT_NOTIFICATION });
  });
}


export const emailInstallmentDue = (ctid) => async (dispatch) => {
  var payload = {
    "id": ctid
  }
  dispatch({ type: CONTRACT_PENDING_ACTION });
  axios.post(AppConfig.apiurl + '/api/emailcontractinstallment', payload, { headers: AuthHeader.header })
  .then(response => {
    var resdata = response.data;
    if(resdata.status==1){
      NotificationManager.success(resdata.message);
    }else{
      NotificationManager.error(resdata.message);
    }
    dispatch({ type: SEND_EMAIL_CONTRACT_NOTIFICATION });
  });
}